<template>
  <div>
    <div class="display-1 font-weight-bold pb-3">
      {{
        param.editName
          ? "Смена названия шаблона"
          : param.template.id
          ? "Сохранить как"
          : "Сохранить шаблон"
      }}
    </div>
    <div v-if="error" class="error--text pb-3 font-weight-medium">
      {{ error }}
    </div>
    <div v-if="param.template.id && !param.editName">
      <v-radio-group v-model="radios" :mandatory="false" class="ma-0 mt-2">
        <v-layout column align-start>
          <div class="d-flex align-center mt-3">
            <v-radio value="edit" class="my-0"></v-radio>
            <label class="py-1">
              <span class="subtitle-1 text--primary font-weight-medium">
                Изменения в текущем шаблоне
              </span>
            </label>
          </div>
          <div class="d-flex align-center mt-3">
            <v-radio value="create" class="my-0"></v-radio>
            <label class="py-1">
              <span class="subtitle-1 text--primary font-weight-medium">
                Новый шаблон
              </span>
            </label>
          </div>
        </v-layout>
      </v-radio-group>
    </div>
    <div class="subtitle-1 pb-3 font-weight-medium">
      <span>
        Сохраненный шаблон будет отображаться в списке всех доступных шаблонов
      </span>
    </div>
    <v-form ref="form" @keyup.native.enter="saveTemplate">
      <label v-if="radios === 'create' || param.editName || !param.template.id">
        Название шаблона
      </label>
      <v-text-field
        v-model="param.template.name"
        v-if="radios === 'create' || param.editName || !param.template.id"
        :rules="[rules.required]"
        height="42"
        solo
        placeholder="Введите название"
      ></v-text-field>

      <v-btn @click="saveTemplate" class="primary mx-0 px-5" :loading="loading">
        {{ param.editName ? "Изменить" : "Сохранить" }}
      </v-btn>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "TemplatesStatisticsEdit",
  data: () => ({
    error: false,
    loading: false,
    // для состояния выбранного типа сохранения (новый или текущий)
    radios: "edit",
    rules: {
      required: v => !!v || "Поле обязательно для заполнения"
    }
  }),
  props: {
    // хранит шаблон: выбранные параметры статистики,
    // ее тип, id если правим существующий шаблон, его название
    param: {
      type: Object
    }
  },
  methods: {
    /**
     * Создание нового шаблона
     */
    createTemplate() {
      this.loading = true;
      // если сохраняем текущий шаблон как новый
      if (this.param.template.id) {
        this.param.template = {
          params: this.param.template.params,
          name: this.param.template.name
        };
      }
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("createTemplate", this.param.template)
          .then(() => {
            this.$store.dispatch("popupInfoOpen", {
              text: "Шаблон успешно сохранен"
            });
            // закрываем popup
            this.$emit("closeDialog");
            resolve();
          })
          .catch(reject);
      });
    },
    /**
     * Измениение шаблона
     */
    editTemplate() {
      this.loading = true;
      // передадим в параметрах callback
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch(
            "editTemplate",
            this.param.editName
              ? { id: this.param.template.id, name: this.param.template.name }
              : this.param.template
          )
          .then(() => {
            this.loading = false;
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: this.param.editName
                ? "Название шаблона успешно изменено"
                : "Шаблон успешно изменен"
            });
            this.param.editName = false;
            // закрываем popup
            this.$emit("closeDialog");
          })
          .catch(reject);
      });
    },
    /**
     * Сохранение шаблона
     */
    saveTemplate() {
      if (this.$refs.form.validate()) {
        if (this.param.template.id && this.radios !== "create")
          this.editTemplate();
        else this.createTemplate();
      }
    }
  }
};
</script>
